import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { ADDRESS_RULE } from '@/common/utils/rules/address.rules';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { OtherDamagedInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/otherDamagedInfo/OtherDamagedInfo.type';
import { PatchDamagedContactInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedContactInformation/patchDamagedContactInformationQueryOptions';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const ContactOtherDamaged = () => {
  const methods = useFormContext<OtherDamagedInfoType>();
  const { id, damagedId } = useParams();
  const phoneNumber = useWatch({
    control: methods.control,
    name: 'contact_information.phone',
  });
  const navigate = useNavigate();

  const { mutateAsync } = useMutation(
    PatchDamagedContactInformationQueryOptions(),
  );
  const isLegal = methods.watch('personal_information.owner_type') === 'legal';
  const loading = false;
  const onSubmit = (formData: OtherDamagedInfoType) => {
    mutateAsync({
      id: id as string,
      formData: {
        ...formData?.contact_information,
        city_code:
          formData.contact_information?.city_code === ''
            ? null
            : formData.contact_information?.city_code,
        phone:
          formData.contact_information?.phone === ''
            ? null
            : formData.contact_information?.phone,
      },
      damaged_id: damagedId as string,
    }).then(() => {
      navigate(-1);
    });
  };
  const previousStep = () => {
    methods?.trigger('personal_information');
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
        id: id!,
        damagedId: damagedId!,
      }).OTHER_OWNER_INFORMATION.owner,
      { relative: 'path', replace: true },
    );
  };

  useEffect(() => {
    methods?.trigger('contact_information.postal_code');
  }, []);

  return (
    <Flex direction="column" gap={32}>
      <Box>
        <MobileInput
          name="contact_information.phone_number"
          label="تلفن همراه "
          rules={{ required: requiredText, ...MOBILE_NUMBER_RULE }}
          defaultValue=""
        />
      </Box>
      {!isLegal && (
        <Box display="flex" flexDirection="row" gap="10px">
          <Box flexBasis={'80%'}>
            <TextInput
              name="contact_information.phone"
              label="تلفن ثابت"
              direction="ltr"
              placeholder="XX-XX-XX-XX"
              key={'phone'}
              rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
              max={8}
              noCharInput={true}
            />
          </Box>
          <Box flexBasis={'30%'}>
            <TextInput
              name="contact_information.city_code"
              key={'city_code'}
              direction="ltr"
              placeholder="کد شهر"
              noCharInput={true}
              rules={{
                minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
                required: {
                  message: requiredText,
                  value: phoneNumber ? true : false,
                },
              }}
              max={3}
            />
          </Box>
        </Box>
      )}
      <Box>
        <TextInput
          label="کدپستی"
          name="contact_information.postal_code"
          optionalLabel
          noCharInput
          placeholder="کدپستی را وارد کنید"
          rules={{ ...POSTAL_CODE_RULE }}
          defaultValue=""
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="آدرس"
          name="contact_information.address"
          optionalLabel
          placeholder="آدرس را وارد کنید"
          rules={{ ...ADDRESS_RULE }}
          defaultValue=""
        />
      </Box>
      <Flex w="100%" gap={16} mb="1rem">
        <Button fullWidth variant="outlined" onClick={previousStep}>
          مرحله قبل
        </Button>{' '}
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت
        </LoadingButton>
      </Flex>
      <ImagesFabMainModal state={'propertyDamaged'} />
    </Flex>
  );
};
export default ContactOtherDamaged;
